// extracted by mini-css-extract-plugin
module.exports = {"container":"ScrollRequired_container__AxlU7","scrollBoxError":"ScrollRequired_scrollBoxError__s4CEM"};